import { render, staticRenderFns } from "./add_dialog.vue?vue&type=template&id=3dfa5b08&scoped=true"
import script from "./add_dialog.vue?vue&type=script&lang=js"
export * from "./add_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa5b08",
  null
  
)

export default component.exports